export default {
  bays: [],
  loading:false
};
